<template>
  <div>
    <!-- Header -->
    <div class="">
      <webhooks-header />
    </div>
    <!-- Webhook Iframe -->
    <div class="">
      <iframe id="myFrame" :src="this.webhookUrl"></iframe>
    </div>
  </div>
</template>

<script>
import getApiCredentials from '@/mixins/externalApi.js'

export default {
  mixins: [getApiCredentials],
  components: {
    WebhooksHeader: () => import('@/components/v2/base/WebhooksHeader.vue')
  },
  computed: {
    webhookUrl () {
      let url = this.$store.state.externalApi.apiCredentials.webhook || ''
      if (!url.startsWith('https://')) {
        url = `https://${url}`
      }
      return url
    }
  },
  async beforeMount () {
    await this.getApiCredentials()
  }
}
</script>

<style>
#myFrame {
  height: 95vh;
  width: 100%;
  padding: 10px 20px;
}
</style>
